import { extraScale, getArrayList } from 'components/widgets/PhasePerformanceChart/PhasePerformance.utils';
import classes from 'components/widgets/PhasePerformanceChart/PhasePerformanceChart.module.scss';
import { PhasePerformanceGridBar } from 'components/widgets/PhasePerformanceChart/components/phasePerformanceGrid/components/phasePerformanceGridBar/phasePerformanceGridBar';

export const PhasePerformanceGrid = ({ monthsDuration }: { monthsDuration: number }) => {
    const list = getArrayList(Math.ceil(monthsDuration * extraScale));
    return (
        <div className={classes.grid}>
            <div className={classes.title}>Months</div>
            {list.map((item) => (
                <PhasePerformanceGridBar key={item} number={item} total={list.length} />
            ))}
        </div>
    );
};
